import { render, staticRenderFns } from "./TabelaEncartes.vue?vue&type=template&id=69af4492&scoped=true"
import script from "./TabelaEncartes.vue?vue&type=script&lang=js"
export * from "./TabelaEncartes.vue?vue&type=script&lang=js"
import style0 from "./TabelaEncartes.vue?vue&type=style&index=0&id=69af4492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af4492",
  null
  
)

export default component.exports